webpackJsonp([73],{

/***/ 1337:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1338);


/***/ }),

/***/ 1338:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(170);

var _datetime2 = _interopRequireDefault(_datetime);

var _nl = __webpack_require__(776);

var _nl2 = _interopRequireDefault(_nl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('nl', _nl2.default);

/***/ })

},[1337]);


// WEBPACK FOOTER //
// app/datetime.nl-1f669ba1847348296d8f.js